var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React from 'react';
import RTooltip from 'react-tooltip-lite';
var POPPER_CLS = 'syl-popper';
var Popper = function (_a) {
    var _b;
    var children = _a.children, content = _a.content, tipContentClassName = _a.tipContentClassName, isOpen = _a.isOpen, getRef = _a.getRef, rest = __rest(_a, ["children", "content", "tipContentClassName", "isOpen", "getRef"]);
    return (React.createElement(RTooltip, __assign({ content: content, arrow: false, useDefaultStyles: false, useHover: false, tipContentClassName: classnames(POPPER_CLS, (_b = {},
            _b[tipContentClassName || ''] = tipContentClassName,
            _b.visible = isOpen,
            _b)), padding: "0", direction: "down-start", zIndex: 1002, isOpen: isOpen, ref: function (t) { return getRef && getRef(t); } }, rest), children));
};
export { Popper, POPPER_CLS };
//# sourceMappingURL=index.js.map